export const collageLayouts = {
  four: [
    // 1️⃣ Classic 2x2
    {
      id: "four-1",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      areas: [
        "a b",
        "c d"
      ]
    },

    // 2️⃣ Big Left + 3 Small Right
    {
      id: "four-2",
      gridTemplateColumns: "2fr 1fr",
      gridTemplateRows: "1fr 1fr 1fr",
      areas: [
        "a b",
        "a c",
        "a d"
      ]
    },

    

    // 4️⃣ Big Right + 3 Small Left
    {
      id: "four-4",
      gridTemplateColumns: "1fr 2fr",
      gridTemplateRows: "1fr 1fr 1fr",
      areas: [
        "a d",
        "b d",
        "c d"
      ]
    }
  ],

  three: [
    // 🟦 Your 3-photo layout (top 2 small + big bottom)
    {
      id: "three-1",
      gridTemplateColumns: "2fr 2fr",
      gridTemplateRows: "1.5fr 2fr",
      areas: [
        "a b",
        "c c"
      ]
    }, {
      id: "three-2",
      gridTemplateColumns: "1.5fr 1.5fr",
      gridTemplateRows: "2fr 2fr",
      areas: [
        "a a",
        "b c"
      ]
    }, {
      id: "three-3",
      gridTemplateColumns: "2fr 1fr",
      gridTemplateRows: "1fr 1fr",
      areas: [
        "a b",
        "a c"
      ]
    }, {
      id: "three-4",
      gridTemplateColumns: "1fr 2fr",
      gridTemplateRows: "1fr 1fr",
      areas: [
        "a c",
        "b c"
      ]
    }
  ],

  two: [
    {
      id: "two-horizontal",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr",
      areas: [
        "a b"
      ]
    },
    {
      id: "two-vertical",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr 1fr",
      areas: [
        "a",
        "b"
      ]
    }
  ]
};
